/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener("theme:product:add", function() {
  const btn = document.querySelector("[data-cart-bar-add-to-cart]");
  if (btn) {
    btn.classList.remove("is-loading", "is-added");
    btn.removeAttribute("disabled");
    btn.disabled = false;
  }
});

document.addEventListener("theme:product:add-error", function() {
  const btn = document.querySelector("[data-cart-bar-add-to-cart]");
  if (btn) {
    btn.classList.remove("is-loading", "is-added");
    btn.removeAttribute("disabled");
    btn.disabled = false;
  }
});
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

